import { useEffect, useState } from "react";
import { Copy, Check, MessageCircle, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Messages() {
  const [settings, setSettings] = useState(null);
  const [copied, setCopied] = useState("");

  useEffect(() => { api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  if (!settings) return null;

  const link = `${settings.public_url}/?ref=qr`;
  const whatsapp = (settings.whatsapp_message || "").replace("{lien}", link);
  const sms = (settings.sms_message || "").replace("{lien}", link);

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    toast.success("Message copié");
    setTimeout(() => setCopied(""), 1500);
  };

  const Card = ({ icon: Icon, title, text, k, accent }) => (
    <div className="bg-[#161920] border border-[#262a33] rounded-xl p-5">
      <div className="flex items-center gap-2 mb-3">
        <Icon className="w-5 h-5" style={{ color: accent }} />
        <h3 className="font-semibold">{title}</h3>
      </div>
      <div className="bg-[#0a0b0e] border border-[#262a33] rounded-xl p-4 text-sm text-[#a0a5b5] whitespace-pre-line mb-3" data-testid={`msg-${k}`}>{text}</div>
      <button onClick={() => copy(text, k)} data-testid={`copy-${k}`}
        className="flex items-center gap-2 bg-[#2a2d35] hover:bg-[#363a45] text-white text-sm font-medium rounded-full px-4 py-2 transition-colors">
        {copied === k ? <Check className="w-4 h-4 text-[#00e676]" /> : <Copy className="w-4 h-4" />} Copier
      </button>
    </div>
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Messages clients</h1>
        <p className="text-[#64697a] mt-1">Modèles prêts à copier pour demander un avis</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card icon={MessageCircle} title="WhatsApp" text={whatsapp} k="whatsapp" accent="#25D366" />
        <Card icon={Smartphone} title="SMS" text={sms} k="sms" accent="#00e676" />
      </div>
      <p className="text-xs text-[#64697a]">Ces messages n'exigent jamais un avis 5 étoiles ni uniquement un avis positif. Vous pouvez personnaliser le texte dans les Paramètres.</p>
    </div>
  );
}
